import { Button } from "../formElements/button"
import React, { Dispatch, SetStateAction, useState } from "react"
import tw from "twin.macro"
import { ReactComponent as DiscordIcon } from "../../assets/profile/discord-black.svg"
import { useTranslation } from "next-i18next"
import { GuildModerator } from "../../graphql/generated/graphql"
import { Modal } from "../../components/modal"
import { useRouter } from "next/router"
import { Routes } from "../../routes"
import Link from "next/link"
import { getDiscordInstallationUrl } from "../../utils/discord"
import { ReactComponent as DiscordBtnIcon } from "../../assets/discord/discord-white.svg"

interface DiscordIntegrationProp {
  showIntegrations: boolean
  guildModeratorData: GuildModerator[]
}

interface GuildModerationButtonProps {
  guildModeratorData: GuildModerator[]
  setShowModal: Dispatch<SetStateAction<boolean>>
}

const GuildModerationButtons = ({ guildModeratorData, setShowModal }: GuildModerationButtonProps) => {
  const router = useRouter()
  return (
    <div tw="flex flex-col space-y-4">
      {guildModeratorData.map((guild) => (
        <Button
          key={`${guild.guildId}`}
          action={`${guild.name}`}
          onClick={() => {
            void router.push({ pathname: Routes.DiscordGuildSettings, query: { guildId: guild.guildId } })
            setShowModal(false)
          }}
        />
      ))}
    </div>
  )
}

export const DiscordIntegration = ({ showIntegrations, guildModeratorData }: DiscordIntegrationProp) => {
  const { t } = useTranslation("profile")
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <Modal
        {...{
          show: showModal,
          setShow: setShowModal,
          component: (
            <div tw="flex flex-col items-center text-center w-full tablet-lg:w-[288px] space-y-4">
              <h2 tw="text-[24px]">{`${t("Integrations.discord_title")}`}</h2>
              <GuildModerationButtons guildModeratorData={guildModeratorData} setShowModal={setShowModal} />
            </div>
          ),
        }}
      />

      <div tw="text-center bg-[#E7D1FA] rounded-md p-4 space-y-3" css={showIntegrations ? tw`block` : tw`hidden`}>
        <div tw="flex items-center justify-center text-[24px] font-bold">
          <DiscordIcon tw="mr-2" />
          {t("Integrations.discord")}
        </div>
        <p
          css={"span {font-weight: bold}"}
          dangerouslySetInnerHTML={{
            __html:
              guildModeratorData.length > 0
                ? t("Integrations.discord_servers", { serverCount: guildModeratorData.length })
                : t("Integrations.discord_what"),
          }}
        />

        {guildModeratorData.length === 0 ? (
          <Link prefetch={false} passHref={true} href={getDiscordInstallationUrl()}>
            <a>
              <Button icon={<DiscordBtnIcon />} twStyle={tw`w-full p-3`} action={`Install`} />
            </a>
          </Link>
        ) : (
          <Button
            action={t("Integrations.manage_btn")}
            onClick={() => {
              setShowModal(true)
            }}
          />
        )}
      </div>
    </>
  )
}
